

import Component from 'generic.basecomponent';
import app from 'app-instance';


export default class RoundDonation extends Component {
    constructor(el) {
        super(el);
        this.options = JSON.parse(this.container.getAttribute('data-round-donation-options'));
        this.radios = [...this.container.querySelectorAll('.js-round-donation__radio')];
        this.customInput = this.container.querySelector('.js-round-donation__custom');
        this.onChange = this.onChange.bind(this);


        this.init();
    }

    init() {
        this.container.addEventListener('change', this.onChange);
        this.customInput.addEventListener('input', this.onChange);

        const value = this.getValue();
        app.emitEvent('donateAmount:change', [value]);
    }

    getValue() {
        let value = null;
        let checkedRadio = null;
        this.radios.forEach((radio) => {
            if (radio.checked) {
                checkedRadio = radio;
            }
        });

        if (checkedRadio) {
            const checkedValue = checkedRadio.value;
            if (checkedValue.toString() === this.options.customDonation.toString()) {
                value = parseFloat(this.customInput.value);
            } else if (checkedValue.toString() === this.options.noDonation.toString()) {
                value = 0;
            } else {
                value = parseFloat(checkedValue);
            }
        }

        return value;
    }

    onChange() {
        const val = this.getValue();
        app.emitEvent('donateAmount:change', [val]);
    }

    destroy() {
        super.destroy();
        this.container.removeEventListener('change', this.onChange);
        this.customInput.removeEventListener('input', this.onChange);
        this.$container.removeClass('js-round-donation-inited');
    }
}



// WEBPACK FOOTER //
// ./app/components/round-donation/js/generic.round-donation.js